import { Component, Input, inject } from '@angular/core';
import { AuthService } from '../../../service/auth.service';
import { cilBellExclamation, cilCheckCircle } from '@coreui/icons';
import { AuthFlowComponent } from '../../../model/types/auth-flow-component.type';
import { ENVIRONMENT } from '../../../../../environments/environment';

/* eslint-disable @angular-eslint/prefer-standalone */
@Component({
  selector: 'app-control-button-submit',
  templateUrl: './control-button-submit.component.html',
  styleUrl: './control-button-submit.component.scss',
  standalone: false,
  providers: [],
})
export class ControlButtonSubmitComponent {
  protected authService = inject(AuthService);

  @Input() parentComponent!: AuthFlowComponent;
  @Input() buttonText!: string;
  @Input() disabled?: boolean;
  @Input() icon!: string;
  @Input() iconSize?: string;
  @Input() iconRotation?: number;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  @Input() onclick: () => void = () => {};

  constructor() {
    const authService = this.authService;

    this.authService = authService;
  }

  iconsStyle = ENVIRONMENT.FONTAWESOME.style;

  icons = {
    cilBellExclamation,
    cilCheckCircle,
  };
}
